<template>
  <div>
    <div class="cas-ban">
      <img src="static/img/home_ban.png" />
    </div>
    <div class="cas-code">
      <img src="static/img/fail.png" v-if="isError" />
      <p>{{ response }}</p>
    </div>
  </div>
</template>
<script>
import { Api } from '../utils/axios';
export default {
  data() {
    return {
      response: "跳转中...",
      isError: false,
    };
  },
  created() {
      this.tozlpt()
  },
  methods: {
      async tozlpt(){
          const res = await Api.getZlpt()
          if(!!res.data){
              window.location.href=res.data;
          }
          else{
              this.response="缺少参数,无法跳转"
          }
      }
  }
};
</script>
<style lang="less" scoped>
.cas-ban {
  padding: 8px 20px;
  margin-top: 50px;
}
.cas-ban img {
  height: 111px;
  width: 100%;
}
.cas-code {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.cas-code img {
  width: 64px;
  height: 64px;
}
.cas-code p {
  color: @attendance-color-1;
  font-weight: 300;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/zlpt.vue